/**
 * Dropdown menus that automatically redirect when an option is selected
 *
 * @param el
 * @constructor
 */
function RedirectDropdown( el ) {
  var t = this;

  t.el = el;
  t.selects = ( el.tagName == 'SELECT' ) ? [el] : el.getElementsByTagName( 'select' );
  t.base = el.getAttribute( 'data-redirect-dropdown-base' );

  for ( var i = 0; i < t.selects.length; i++ ) {
    t.selects[i].addEventListener( 'change', function() {
      t.redirect(this);
    } );
  }
}

/**
 * Redirect to the URL in selected value, or redirect back to base if
 * blank option is selected
 * 
 * @param select
 */
RedirectDropdown.prototype.redirect = function (select) {
  if ( select.value !== '' && select.value !== 0 ) {
      window.location = select.value;
  } else {
    window.location = this.base;
  }
};

module.exports = RedirectDropdown;